import React from 'react'
import basilique from '../../../ASSETS/tourisme/Image/baselique.jpg'
import mosque from '../../../ASSETS/tourisme/Image/Mosque.jpg'
import cascade from '../../../ASSETS/tourisme/Image/cascade_man.jpg'
import Footer from '../../COMPONENTS/Footer/Footer'
import {Link} from 'react-router-dom'
import { useState, useEffect } from 'react';
import Loading from '../../COMPONENTS/Loading/Loading'
import lieu from '../../../ASSETS/tourisme/icone/pin.png'
import SaintPaul from '../../../ASSETS/tourisme/Image/cathedralePaul.jpg'
import banco from '../../../ASSETS/tourisme/Image/banco.jpg'
import fort from '../../../ASSETS/tourisme/Image/fortDabou.jpg'
import BackImage from './BackImage'
import BarniereCD from './BarniereCD'
import { VscEye } from "react-icons/vsc";
import Lieu from '../../../API/tourisme/lieu/index'
import { AnnoncesProps} from "../../../props";
import { useTranslation } from 'react-i18next'
import { ResultContext } from '../../../ResultContext'



function Culture() {

  localStorage.setItem('url', JSON.stringify('/'));

  function truncate (str : any) {
    return str.length > 200 ? str.substring(0, 200) + "..." : str;
  }

  const [loading, setLoading] = useState(true);

  const [tourisme, setTourisme] = useState<AnnoncesProps[]>([]);

  //recherche
  const [searchTerm, setSearchTerm] = useState("");
  const [itemFilters, setItemFilters] = useState<AnnoncesProps[]>([]);
  const contexts = React.useContext(ResultContext)
  
 
   let code = localStorage.getItem('code') ? localStorage.getItem('code') : localStorage.getItem('is_code');
    const getAllLieu = () => {
      Lieu.getAllData(code)
        .then((res:any) => {
          //console.log(res)
            if (res.data.status === 200 && contexts?.results.culture === null ) {
              
              setTourisme(res.data.data)
            }
        })
        .catch((err:any) => {
            console.log("Erreur lors de l'appel a l'API ", err);
        })
        .finally(() => {
            setLoading(false);
        })
    }

    //Recherche
  const handleSearchInputChange = (event : any) => {
    setSearchTerm(event.target.value);
    //Filtrer la recherche
    if(event.target.value !== ""){  
        setItemFilters(tourisme.filter((item) =>
            item.title_announce.toLowerCase().includes(event.target.value.toLowerCase()))
        );
    }

  };   

    
  useEffect(() => {

    getAllLieu();
  
  }, [])

  useEffect(()=>{
    console.log(tourisme)
  },[tourisme])

   useEffect(()=>{
      if(contexts?.results.culture)
      {
        setTourisme(contexts?.results.culture)
      }
   },[contexts?.results.culture])
   
  
  const {t} = useTranslation() as {t:(key:string)=>string}
  return (
    <div>

      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
        {/* Back image */}
          <BackImage/>

        {/* barre de recherche culture */}
        <div className='flex items-center justify-center pb-10 '>
          <div className='flex items-center justify-center px-4 space-x-2 border-2 shadow-xl '>
              <svg xmlns="http://www.w3.org/2000/svg" width="32.52" height="32" viewBox="0 0 42.52 42">
                <g id="loupe" transform="translate(0.001)">
                  <path id="Tracé_134" data-name="Tracé 134" d="M27.408,22.321l13.8,12.354a4.227,4.227,0,0,1,.047,6.076A4.354,4.354,0,0,1,35.1,40.7L22.6,27.081a16.3,16.3,0,0,0,4.806-4.76ZM4.029,3.981a13.881,13.881,0,0,1,19.459,0,13.474,13.474,0,0,1,0,19.222,13.88,13.88,0,0,1-19.459,0A13.475,13.475,0,0,1,4.029,3.981ZM8.036,19.245a8.165,8.165,0,0,0,11.446,0,7.926,7.926,0,0,0,0-11.307,8.165,8.165,0,0,0-11.446,0,7.926,7.926,0,0,0,0,11.307Zm0,0" transform="translate(0)" fill="#cecece"/>
                </g>
              </svg>
              {/* Search culture */}
                <input className='md:w-[700px] xs:w-[400px] s:w-[230px] sm:w-[300px]  bg-transparent  border-none' type='search' placeholder={t('Entrer un site touristique ou une ville')}
                name='searchItem'
                value={searchTerm}
                onChange={handleSearchInputChange}/>
          </div>
        </div>

            {/* container2 */}
            <div className='flex flex-col items-center justify-center w-screen px-5 py-10 my-20 container2_home md:space-y-6 '>
              <div className='flex flex-col items-center justify-center pb-10 space-y-3 text-white'>
                <p className='md:text-3xl sm:text-xl'> {t("Culture")} & <span className='text-orange-400'>{t("Découverte")},</span></p>
                <p className='md:text-lg sm:text-lg'>{t("Découvrez les différents sites touristiques à visités et diverses activités sur la plateforme")} </p>
              </div>

              <div className='grid gap-8 pb-10 lg:grid-cols-4 md:grid-cols-3 xs:grid-cols-2 sm:grid-cols-1 '>
               
                {
                 searchTerm !== "" ? itemFilters.map((list, index )=> (
                    <div key={index} className='flex flex-col items-center'>
                      {/* titre */}
                      <div className='flex items-center space-x-2 bg-[#FCCA46] py-2 pl-3 w-[250px] rounded-md relative top-12 md:right-9'>
                        {/* icone */}
                        <img src={lieu} alt='iconeLieu' className='w-6' />
                        {/* texte */}
                        <p className='text-sm text-white '>{list.title_announce}</p>
                      </div>
                      {/* image du site touristique */}

                      <img src={`data:image/png;base64,${list[0]}`} alt={list.title_announce} className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-700 md:w-[350px] cursor-zoom-in  sm:w-[320px] h-[250px] s:w-[260px] rounded-md' />

                      {/* bloc blan description */}
                      <div className='md:w-[320px] rounded-md  sm:w-[300px] s:w-[260px] h-[250px]  bg-white p-5 relative bottom-12'>
                        <p className='md:w-[280px] sm:w-[260px] s:w-[230px] '>
                             {truncate(list.description_announce)}
                        </p>
                        <p className='md:w-[280px] sm:w-[260px] s:w-[230px] '>
                             {list.price_announce} FCFA
                        </p>
                        <Link to="/culture/Voir_Plus/#voir-plus" 
                                state={ 
                                  list.id_announce 
                                }
                                > 
                              <div className='grid mt-4 place-items-end '>
                                <button className='flex items-center h-8 px-2 space-x-2 text-sm font-bold text-white transition-transform transform bg-orange-400 rounded active:scale-75 '>
                                  <p>{t("Voir plus")}</p>
                                  <VscEye className='text-lg' />
                                </button>
                              </div>
                        </Link>
                      </div>
                    </div>
                  )) :
                  (

                    tourisme.map((list, index )=> (
                      <div key={index} className='flex flex-col items-center'>
                        {/* titre */}
                        <div className='flex items-center space-x-2 bg-[#FCCA46] py-2 pl-3 w-[250px] rounded-md relative top-12 md:right-9'>
                          {/* icone */}
                          <img src={lieu} alt='iconeLieu' className='w-6' />
                          {/* texte */}
                          <p className='text-sm text-white '>{list.title_announce}</p>
                        </div>
                        {/* image du site touristique */}
  
                        <img src={`data:image/png;base64,${list[0]}`} alt={list.title_announce} className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-700 md:w-[350px] cursor-zoom-in  sm:w-[320px] h-[250px] s:w-[260px] rounded-md' />
  
                        {/* bloc blan description */}
                        <div className='md:w-[320px] rounded-md  sm:w-[300px] s:w-[260px] h-[250px]  bg-white p-5 relative bottom-12'>
                           <div className='flex justify-between w-full'>
                                <p >
                                {truncate(list.description_announce)}
                                </p>
                                <p >
                                  {list.price_announce} FCFA
                                </p>
                           </div>
                          
                          <Link to="/culture/Voir_Plus/#voir-plus" state={list.id_announce}> 
                          <div className='grid mt-4 place-items-end '>
                            <button className='flex items-center h-8 px-2 space-x-2 text-sm font-bold text-white transition-transform transform bg-orange-400 rounded active:scale-75 '>
                              <p>{t("Voir plus")}</p>
                              <VscEye className='text-lg' />
                            </button>
                          </div>
                          </Link>
                        </div>
                      </div>
                    
                    )))
                }

              </div>
            </div>

          {/* Banniere culture et decouverte */}
            <BarniereCD/>


           <Footer/>
        </>
      )}
    </div>
  )
}

export default Culture
